import { useSuspenseQuery } from '@tanstack/react-query';
import { queryKey } from '../../../constant/queryKey';
import { categoryService } from 'shared/src/api';

export const useOverviewCategories = () => {
  return useSuspenseQuery({
    queryKey: queryKey.overviewCategories(),
    queryFn: () => categoryService.getOverviewCategories(),
  });
};
